import { useState, useCallback, useMemo } from 'react'
import type { PaginationParams } from '@/types'

interface UsePaginationOptions {
  defaultPageSize?: number
  pageSizeOptions?: number[]
}

const DEFAULT_PAGE_SIZE = 50
const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 50, 100]

export function usePagination(options: UsePaginationOptions = {}) {
  const {
    defaultPageSize = DEFAULT_PAGE_SIZE,
    pageSizeOptions = DEFAULT_PAGE_SIZE_OPTIONS,
  } = options

  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(defaultPageSize)

  const resetPage = useCallback(() => setPage(1), [])

  const handlePageSizeChange = useCallback((newSize: number) => {
    setPageSize(newSize)
    setPage(1)
  }, [])

  const paginationParams: PaginationParams = useMemo(
    () => ({
      maxResultCount: pageSize,
      skipCount: (page - 1) * pageSize,
    }),
    [page, pageSize]
  )

  return {
    page,
    pageSize,
    pageSizeOptions,
    setPage,
    setPageSize: handlePageSizeChange,
    resetPage,
    paginationParams,
  }
}
